import ReferencePathService from "./referencePathService";
import {
  IReferencePathNodeUserData,
  IReferencePathNodeSpecific, IReferencePathReferenceDetails, ReferencePathReferenceDetailsType
} from "~/interfaces/referencePathInterfaces"
import {ReferenceNodeGenericTypeMap, ReferenceNodeType} from "~/enums/referenceNodeType";
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import {PermitteeType} from "~/enums/permitteeType";

export default class UserDataPathService extends ReferencePathService {
  get referenceDetails(): IReferencePathReferenceDetails {
    return {type: ReferencePathReferenceDetailsType.User};
  }

  get imposterModelType(): ModelType {
    return this.referenceModelType
  }

  constructor(private userDataNode: IReferencePathNodeUserData) {
    super();
  }

  get label(): string {
    switch (this.userDataNode.reference_type) {
      case ReferenceNodeType.OriginalSubmitter:
      case ReferenceNodeType.StepCompleter: // intentional fall-through
        switch (this.userDataNode.reference_id) {
          case 'first_name':
            return 'First name';
          case 'last_name':
            return 'Last name';
          case 'email':
            return 'Email';
          case 'original_submitter':
            return 'Original Submitter'
          case 'current_step_completer':
            return 'Current Step Completer'
          case 'proxy_submitter':
            return 'Proxy Submitter'
          default:
            this.referenceIdForTypeError('UserDataPathService#label', this.userDataNode);
            break;
        }
        break;
      case ReferenceNodeType.RecordHolder:
        switch (this.userDataNode.reference_id) {
          case 'record_holder':
            return 'Record Holder';
          default:
            this.referenceIdForTypeError('UserDataPathService#label', this.userDataNode);
            break;
        }
        break;
      default:
        this.referenceTypeError('UserDataPathService#label', this.userDataNode);
        break;
    }
  }

  get nodes(): (IReferencePathNodeUserData)[] {
    return [this.userDataNode];
  }

  reference(): ReferenceNodeType {
    return this.userDataNode.reference_type;
  }

  get referenceGenericModelType(): GenericType {
    return ReferenceNodeGenericTypeMap[this.reference()]
  }

  get referenceModelType(): ModelType {
    switch (this.userDataNode.reference_id) {
      case 'record_holder':
      case 'email':
      case 'original_submitter':
      case 'current_step_completer':
      case 'proxy_submitter':
        return ModelType.User;
      default:
        return this.referenceGenericModelType
    }
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('UserDataPathService', this.userDataNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false;
  }

  get referencePermitteeType(): PermitteeType {
    switch (this.userDataNode.reference_type) {
      case ReferenceNodeType.RecordHolder:
        return PermitteeType.objectOwner;
      case ReferenceNodeType.OriginalSubmitter:
        return PermitteeType.originalSubmitter;
      case ReferenceNodeType.AllCompleters:
        return PermitteeType.allCompleters;
      case ReferenceNodeType.StepCompleter:
        return PermitteeType.stepCompleters;
    }
  }
}